import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
  import { DateFilter, TopDisplay} from "../../../components";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState ,useEffect} from "react";
  import styled from "@emotion/styled";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import apiCall from '../../../utils/apiCall';
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { downloadApi } from "../../../api";
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import {useAtom,atom} from 'jotai'
  import { openAtom, notificationAtom, openNAtom, modalAtom } from "../../../context";
  import { Loader } from "../../../customs";
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import { FaRegFileAlt as FileIcon } from "react-icons/fa";
  import ReactPaginate from 'react-paginate';
  import {
    Grid,
    GridItem,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
  } from '@chakra-ui/react'
  
  const indexAtom = atom<number | null>(null);
  const list = [
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
  ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `
  
  export default function TranscriptReport() {
    const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const [date_range,set_date_range] = useState<any>({start:'',end:''});
    const [selected_status,set_selected_status] = useState<null | string>(null);
    const {data:all_transcript_request,isLoading} = useQuery<any>(['all-exam-transcript-requests'],{
      queryFn: async ()=> await apiCall().get('/Exam/TranscriptRequests'),
      select(data:any){return data.data.Data}
    })
    const [search,set_search] = useState('');
  
    const [filter_data,set_filter_data] = useState<any>(all_transcript_request);
  
    
    const handleSearch = (e:any)=>{
      let val = e.target.value;
      set_search(val);
      if(val){
        let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
        if(new_data.length > 0)set_filter_data(new_data)
        else set_filter_data(all_transcript_request)
      }
      else set_filter_data(all_transcript_request)
    }

    const handleFilterByStatus = (value:string)=>{
       if(!value){
        set_selected_status('');
        return;
       }
       set_selected_status(value);
       let data = all_transcript_request?.filter((e:any) => e.Status === value);
       if(data && data.length > 0){
        set_filter_data(data);
       }
       else{
        set_filter_data([])
       }
    };
  
    const itemsPerPage = 100;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
  
    useEffect(()=>{
      if(selected_status){
        let data = all_transcript_request.filter((eData:any) => eData.Status.toLowerCase() === selected_status.toLowerCase);
        if(data.length > 0){
          set_filter_data(data);
        }
      }
      else{
        set_filter_data(all_transcript_request);
      }
    },[selected_status])
  
    useEffect(()=>{
      set_filter_data(all_transcript_request)
    },[all_transcript_request])

    
    const {mutate:handleDownload,isLoading:isDownloading} = useMutation({
        mutationKey:[],
        mutationFn:async ()=> {
          const url = `/ExamReport/downloadExamTranscriptReport?status=${selected_status}&startDate=${date_range.start || '1909-08-13'}&endDate=${date_range.end || '2100-08-13'}`,method = "POST",body = {},config = {},download = true;
          return await downloadApi(url,method,body,config,download)
    
        },
        onSuccess:async(data:any)=>{
          //initial the download 
          //console.log(data,'download data')
          let file = data;
         
          if(file){
            
            const url = window.URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Transcript-report-list.xlsx");
            document.body.appendChild(link);
            link.click();
            //console.log(file,'data')
            set_notification({
              type:'success',
              message:data?.data?.Message || 'Transcript Report downloaded Successfully'
            })
            set_Nopen(true);
          }
          else{
            set_notification({
              type:'error',
              message:'Oooops! Error Occured trying to download file'
            })
            set_Nopen(true);
          }
          
        },
        onError(error:any, variables, context) {
          set_notification({
            type:'error',
            message:error?.data?.Message || 'Error Occured'
          })
          set_Nopen(true);
        },
        onSettled:()=>{
          set_open(false);
        }
    
      } )
  
    return (
      <>
     {isLoading?<Loader />:
  
      <Box>
        <TopDisplay label="Transcript Report" button_array={[
          
            <Button  color="var(--white-color)" 
            bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
            
            onClick={()=>handleDownload()} disabled={isDownloading}
          >{isDownloading?" DownLoading....":'Download Transcript Report'}</Button>,
           
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
              <span style={{position:'absolute',zIndex:'1',
              right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
            </InputGroup>
            <Select placeholder="Status" width="130px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)" onChange={(e:any)=>handleFilterByStatus(e.target.value)}>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Dispatched">Dispatched</option>
            </Select>
            <DateFilter text="Date Range" onChange={set_date_range} />
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Transcript Report</Heading>
            <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
          {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
              <Th sx={HeadStyle}>Id</Th>
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>Destination</Th>
                <Th sx={HeadStyle}>Address</Th>
                <Th sx={HeadStyle}>Paid</Th>
                <Th sx={HeadStyle}>Status</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.Id}>
                <Td sx={DataStyle}>{eCandidate.Id}</Td>
                <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                <Td sx={DataStyle}>{eCandidate.DestinationName}</Td>
                <Td sx={DataStyle}>{eCandidate.DestinationAddress}</Td>
                <Td sx={DataStyle}>{eCandidate.PaymentCompleted? 'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Pending Transcript Request'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />
  
        </StylePaginateBox>
  
      </Box>
  }
  </>
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  
  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }
  const Option = (props:any)=>{
    const index = props.index;
    const candidate= props.candidate;
    const [ind,set_index] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_N_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);
  
    const onClick=()=>{
      if(index === ind){
        set_index(null);
        return;
      }
      set_index(index);
    }
  
   
    const handleViewDetails = () =>{
      set_index(null);
      set_modal({
        header:'Candidate Details',
        content:<ViewDetails candidate={candidate} />
      })
      set_open(true);
    }
    
    const handleViewDoc = () =>{
      set_modal({
        header:'View Submitted Document',
        content:<iframe src={props?.Path} title="Forms" style={{width:'90dvh',height:'90dvw'}}>
  
        </iframe>
      })
      set_open(true);
    }
    
  const ViewDetails = (props:any) =>{
    return(
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex align="center" gap="20px">
        <Flex gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Student NO</Text>
          <Text fontWeight="500">  {props.candidate.StudentNo}</Text>
        </Flex>
      </Flex>
      <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
       
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Destination</Text>
          <Text fontWeight="500">{props.candidate.DestinationName || 'N/A'}</Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Address</Text>
          <Text fontWeight="500">{props.candidate.DestinationAddress || 'N/A'}</Text>
        </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Amount</Text>
          <Text fontWeight="500">
            {props.candidate.TranscriptAmount || 'N/A'}
          </Text>
        </GridItem >
        {/* <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Dispatch Date</Text>
          <Flex fontWeight="500">
          {format(new Date(props.Candidate.TranscriptDispatchDate), "dd/MM/yyyy")}
          </Flex>
        </GridItem > */}
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Comments</Text>
          <Text fontWeight="500">
            {props.candidate.Comments || 'N/A'}
          </Text>
        </GridItem >
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Paid</Text>
          <Text fontWeight="500">
            {props.candidate.PaymentCompleted || 'N/A'}
          </Text>
        </GridItem >
        <GridItem as={Flex} gap="20px">
          <Text width="150px"  fontWeight="500" color="var(--light-text)">Created Date</Text>
          <Text fontWeight="500">
            {props.candidate.CreateDate || 'N/A'}
          </Text>
        </GridItem >
        <GridItem gap="40px">
            <span>Submitted Document:</span>
            <Box >
              <span onClick={handleViewDoc}><FileIcon /></span>
              <span onClick={handleViewDoc}>{props.Path?.split('\\')?.at(-1) || props.Path?.split('/')?.at(-1)}</span>
            </Box>
          </GridItem>
        <GridItem as={Flex} gap="20px">
          <Text width="150px" fontWeight="500" color="var(--light-text)">Status</Text>
          <Text fontWeight="500">{props.candidate.Status || 'Pending'}</Text>
        </GridItem>
      </Grid>
    </Flex>
    )}
  
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
        <GridItem sx={sx} p="8px 4px" onClick={handleViewDetails}>View Details</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
  }
